import { Navigate } from 'react-router-dom';
import AuthGuard from '../auth/AuthGuard';
import AuthTrainerGuard from '../auth/AuthTrainerGuard';
import { PATH_TRAINER_DASHBOARD } from './paths';
import {
  TrainerDashboardLayout,
  TrainerDashboard,
  TrainerHorseListPage,
  TrainerWorkoutHorseListPage,
  AddHorsePage,
  UserAccountPage,
  EcommerceShopPage,
  EcommerceCheckoutPage,
  EcommerceProductDetailsPage,
  EcommerceSubscriptionShopPage,
  EcommerceSubscriptionDetailsPage,
  SubscriptionListPage,
  MyOrdersPage,
  WorkoutDetailsPage,
} from './elements';

export const trainerRoutes = {
  path: 'trainer',
  element: (
    <AuthGuard>
      <AuthTrainerGuard>
        <TrainerDashboardLayout />
      </AuthTrainerGuard>
    </AuthGuard>
  ),
  children: [
    { element: <Navigate to="/trainer/app" replace />, index: true },
    { path: 'app', element: <TrainerDashboard /> },
    {
      children: [
        { path: PATH_TRAINER_DASHBOARD.ecommerce.list, element: <EcommerceShopPage /> },
        {
          path: PATH_TRAINER_DASHBOARD.ecommerce.product,
          element: <EcommerceProductDetailsPage />,
        },
        {
          path: PATH_TRAINER_DASHBOARD.ecommerce.subscription,
          element: <EcommerceSubscriptionShopPage />,
        },
        {
          path: PATH_TRAINER_DASHBOARD.ecommerce.subscriptiondetail,
          element: <EcommerceSubscriptionDetailsPage />,
        },
        { path: PATH_TRAINER_DASHBOARD.ecommerce.checkout, element: <EcommerceCheckoutPage /> },
      ],
    },
    {
      path: 'horse',
      children: [
        { element: <Navigate to="/trainer/horse" replace />, index: true },
        { path: PATH_TRAINER_DASHBOARD.horse.list, element: <TrainerHorseListPage /> },
        { path: PATH_TRAINER_DASHBOARD.horse.create, element: <AddHorsePage /> },
      ],
    },
    {
      path: 'workout',
      children: [
        { element: <Navigate to="/trainer/workout" replace />, index: true },
        { path: PATH_TRAINER_DASHBOARD.workout.list, element: <TrainerWorkoutHorseListPage /> },
        { path: PATH_TRAINER_DASHBOARD.workout.details, element: <WorkoutDetailsPage /> },
      ],
    },
    {
      path: 'user',
      children: [
        { element: <Navigate to={PATH_TRAINER_DASHBOARD.user.account} replace />, index: true },
        { path: 'account', element: <UserAccountPage /> },
      ],
    },
    {
      path: 'order',
      children: [{ path: PATH_TRAINER_DASHBOARD.order.list, element: <MyOrdersPage /> }],
    },
    {
      path: 'subscription',
      children: [
        { path: PATH_TRAINER_DASHBOARD.subscription.list, element: <SubscriptionListPage /> },
      ],
    },
  ],
};